/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Import_TitleInputs */

const en_google_drive_import_title = /** @type {(inputs: Google_Drive_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from Google Drive`)
};

const es_google_drive_import_title = /** @type {(inputs: Google_Drive_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde Google Drive`)
};

/**
* | output |
* | --- |
* | "Import from Google Drive" |
*
* @param {Google_Drive_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_import_title = /** @type {((inputs?: Google_Drive_Import_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Import_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_import_title(inputs)
	return en_google_drive_import_title(inputs)
});